import { render, staticRenderFns } from "./AppointmentBookedTypesTaken.vue?vue&type=template&id=5d044b84"
import script from "./AppointmentBookedTypesTaken.vue?vue&type=script&lang=ts"
export * from "./AppointmentBookedTypesTaken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports